/**
 * Piezas ep-* (Sección personalizable y bloques de tema).
 * - Animación de entrada [data-ep-anim] con un IntersectionObserver ligero. Respeta
 *   prefers-reduced-motion y no anima lo que ya está en pantalla al cargar (no retrasa el LCP).
 * - Video de YouTube o Vimeo con fachada: el iframe se crea al hacer clic (o al entrar en
 *   pantalla si el bloque tiene reproducción automática).
 * - Botón "Agregar al carrito" de ep-producto por AJAX cuando el tema tiene carrito lateral;
 *   si no, el formulario se envía de forma normal.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animObserver = null;

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  function reveal(el) {
    el.classList.add('ep-in');
  }

  function initAnimations(scope) {
    var els = (scope || document).querySelectorAll('[data-ep-anim]:not(.ep-in)');
    if (!els.length) return;
    var designMode = window.Shopify && window.Shopify.designMode;
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, reveal);
      return;
    }
    if (!animObserver) {
      animObserver = new IntersectionObserver(function (entries) {
        var i = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.style.transitionDelay = Math.min(i * 80, 320) + 'ms';
          i += 1;
          reveal(el);
          animObserver.unobserve(el);
          el.addEventListener('transitionend', function () { el.style.transitionDelay = ''; }, { once: true });
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    // Lo que ya se ve al cargar queda visible sin animar; el resto espera a entrar en pantalla.
    Array.prototype.forEach.call(els, function (el) {
      if (inViewport(el)) reveal(el);
    });
    root.classList.add('ep-anim-on');
    Array.prototype.forEach.call(els, function (el) {
      if (!el.classList.contains('ep-in')) animObserver.observe(el);
    });
  }

  /* --- Video externo con fachada --- */
  function loadExternalVideo(btn) {
    if (!btn || !btn.isConnected) return;
    var iframe = document.createElement('iframe');
    iframe.src = btn.getAttribute('data-ep-video-src');
    iframe.title = btn.getAttribute('data-ep-video-title') || '';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.setAttribute('allowfullscreen', '');
    iframe.loading = 'lazy';
    btn.replaceWith(iframe);
  }

  function initExternalAutoplay(scope) {
    var btns = (scope || document).querySelectorAll('[data-ep-video-src][data-ep-autoplay]');
    if (!btns.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        loadExternalVideo(entry.target);
      });
    }, { rootMargin: '200px 0px' });
    Array.prototype.forEach.call(btns, function (b) { io.observe(b); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ep-video-src]');
    if (!btn) return;
    e.preventDefault();
    loadExternalVideo(btn);
  });

  /* --- Agregar al carrito (ep-producto) --- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-ep-add')) return;
    // Sin carrito lateral no hay dónde mostrar el resultado: envío normal a /cart.
    if (typeof window.refreshCartDrawer !== 'function' || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var error = form.querySelector('[data-ep-error]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    if (error) error.textContent = '';
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // El tema intercepta fetch a /cart/add y abre el carrito lateral con el contenido actualizado.
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (res.ok) return null;
        return res.json().then(function (data) {
          throw new Error((data && (data.description || data.message)) || '');
        });
      })
      .catch(function (err) {
        if (error) error.textContent = (err && err.message) || error.getAttribute('data-ep-error');
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
  });

  function init(scope) {
    initAnimations(scope);
    initExternalAutoplay(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el) return;
    if (el.hasAttribute('data-ep-anim')) reveal(el);
    if (el.tagName === 'DETAILS' && el.classList.contains('ep-acordeon')) el.open = true;
  });
})();
